import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import Slider from 'react-slick';
import {Button as ButtonUI} from 'ui';

export const Section = styled('div')({
  width: '100%',
  paddingTop: 30,
  paddingBottom: 10,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const DarkSection = styled('div')({
  width: '100%',
  paddingTop: 30,
  paddingBottom: 10,
  backgroundColor: colors.darkBrown,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const SectionTitle = styled('div')({
  fontFamily: fonts.title,
  fontSize: 22,
  fontWeight: 'bold',
  textAlign: 'center',
  color: colors.black,
  marginBottom: 20,
  paddingLeft: 20,
  paddingRight: 20,
});

export const DarkSectionTitle = styled('div')({
  fontFamily: fonts.title,
  fontSize: 26,
  fontWeight: 'bold',
  textAlign: 'center',
  color: colors.white,
  marginBottom: 40,
  paddingLeft: 20,
  paddingRight: 20,
});

export const GiftSlider = styled(Slider)({
  width: '100%',
  '& .slick-track': {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
  },
  '& .slick-slide': {
    height: 'auto',
    '& > div': {
      height: '100%',
    },
  },
  '& .slick-dots': {
    paddingTop: 40,
  },
});

export const MorePointsButton = styled(ButtonUI)({
  border: `1px solid ${colors.caramel}`,
  margin: '20px auto 0',
  '& span': {
    padding: '12px 20px',
    fontSize: 16,
  },
});
